import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
  openUnsavedChangesDialog(): Observable<boolean>;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  // If the session has been cleared (forced logout), never block navigation.
  if (!sessionStorage.getItem('idToken')) return true;
  if (!component.hasUnsavedChanges()) return true;
  return component.openUnsavedChangesDialog();
};
